import { Modal, Button } from "antd";
import { toast } from "sonner";
import { update_message } from "../../api/messages";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";

interface Props {
  visible: boolean;
  onCancel: () => void;
  onConfirm?: () => void;
  messageData: any;
  onUpdated?: (updated: any) => void;
  messagePreview?: string;
}

const ArchiveMessageModal = ({
  visible,
  onCancel,
  onConfirm,
  messageData,
  onUpdated,
  messagePreview,
}: Props) => {
  const handleArchive = async () => {
    try {
      const id = messageData?.id || messageData?.messageId;
      if (!id) {
        toast.error("Message introuvable");
        return;
      }
      const receivers =
        messageData?.receivers || messageData?.MessageRecipients || [];
      const r = {
        TeacherIds: [] as string[],
        StudentIds: [] as string[],
        ParentIds: [] as string[],
        StaffIds: [] as string[],
        ClassIds: [] as string[],
      };
      receivers.forEach((rec: any) => {
        const rid = rec.receiverId || rec.receiver_id || rec.id;
        const rtype = (
          rec.receiver_type ||
          rec.receiverType ||
          rec.receiver
        )?.toUpperCase();
        if (!rid || !rtype) return;
        if (rtype === "TEACHER") r.TeacherIds.push(String(rid));
        else if (rtype === "STUDENT") r.StudentIds.push(String(rid));
        else if (rtype === "PARENT") r.ParentIds.push(String(rid));
        else if (rtype === "STAFF") r.StaffIds.push(String(rid));
        else if (rtype === "CLASS") r.ClassIds.push(String(rid));
      });
      const payload = {
        target: messageData?.target_type || messageData?.target,
        message: messageData?.message,
        type: messageData?.message_type,
        studentId: r.StudentIds,
        classId: r.ClassIds,
        parentId: r.ParentIds,
        teacherId: r.TeacherIds,
        staffId: r.StaffIds,
        message_sent: !!messageData?.message_sent,
        draft: !!messageData?.draft,
        archive: true,
      };
      // console.log("PayloadData: ", payload);
      const response = await update_message(id, payload);
      console.log("Response archive: ", response);
      toast.success("Message archivé");
      onUpdated && onUpdated(payload);
      onConfirm && onConfirm();
      onCancel();
    } catch (e: any) {
      toast.error(e?.response?.data?.message || "Erreur lors de l'archivage");
    }
  };

  return (
    <Modal
      title="Archiver le message"
      open={visible}
      onCancel={onCancel}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button onClick={onCancel}>Annuler</Button>
          <Button type="primary" danger onClick={handleArchive}>
            Archiver
          </Button>
        </div>
      }
    >
      <div style={{ maxHeight: 200, overflow: "auto" }}>
        <p className="mb-2">Voulez-vous vraiment archiver ce message ?</p>
        {messagePreview && (
          <div className="text-muted small" style={{ whiteSpace: "pre-wrap" }}>
            {messagePreview}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default withPermission(
  ArchiveMessageModal,
  [buildPermission(Resource.MESSAGE, Action.UPDATE)],
  "masquer",
);
